<template>
	<div class="mixin">
		<div class="mixin-mask" v-if="mixinIsErrorShow"></div>
		<div class="mixin-dialog" v-if="mixinIsErrorShow">
			<div class="mixin-title">提示！</div>
			<div class="mixin-text">
				<p>现在退出会作废当前的考核进度，请慎重考虑</p>
			</div>
			<div class="mixin-flex">
				<div class="mixin-footer-modl" @click="handleMinxinOk">确定</div>
				<div class="mixin-footer-modl" @click="handleMinxinClose">取消</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				mixinIsErrorShow: false,
				routerNum: null,
			};
		},
		mounted() {
			this.routerNum = Number(this.$route.query.num);
			if (!this.routerNum || this.routerNum < 7) {
				if (window.history && window.history.pushState) {
					history.pushState(null, null, document.URL);
					window.addEventListener("popstate", this.goPageBefore, false);
				}
			}
		},
		destroyed() {
			if (!this.routerNum || this.routerNum < 7) {
				window.removeEventListener("popstate", this.goPageBefore, false);
			}
		},
		methods: {
			// 返回的拦截内容
			goPageBefore() {
				// this.mixinIsErrorShow = true;
				this.mixinIsErrorShow = false;
				this.$router.replace({
					path: "/index/home2026",
					query: {
						isLogin: false
					},
				});
			},

			//确认按钮
			handleMinxinOk() {
				this.mixinIsErrorShow = false;
				this.$router.replace({
					path: "/index/home2026",
					query: {
						isLogin: false
					},
				});
			},

			//取消按钮
			handleMinxinClose() {
				this.mixinIsErrorShow = false;
				if (window.history && window.history.pushState) {
					history.pushState(null, null, document.URL);
					window.addEventListener("popstate", this.goPageBefore, false);
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.mixin {
		.mixin-mask {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 9997;
			background: rgba(255, 255, 255, 0.8);
		}

		.mixin-dialog {
			width: 612px;
			height: 550px;
			position: fixed;
			z-index: 9998;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			background: #ffffff;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;

			.mixin-title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
				text-align: center;
				margin-top: 50px;
			}

			.mixin-text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				padding: 0 50px;
				text-align: center;
			}

			.mixin-flex {
				display: flex;
				margin: 0 50px;
			}

			.mixin-footer-modl {
				width: 200px;
				margin: 0 auto;
				height: 79px;
				background: linear-gradient(90deg, #1e3c72, #2a5298);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				text-align: center;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;
				line-height: 79px;
				letter-spacing: 2px;
				border-radius: 40px;
				margin-top: 50px;
			}
		}
	}
</style>